var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-block",class:{ 'text-block--border-top': _vm.borderTop }},[_c('content',{staticClass:"text-block__content",class:['text-block__content--' + _vm.width]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }